import gender from './gender';

export default {
  ...gender,
};
